<!-- 
Dialog for removing a provider from the levy collection that had previously been manually added.

This is done by deleting the "AddProvider" override.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>Remove provider from levy collection</v-toolbar-title>
      </v-toolbar>
      <our-busy-indicator :show="state.processing"/>
      <v-card-text>
        <p>
          This provider was previously added to the levy collection by override.
        </p>
        <p>
          Are you sure you want to remove them from the levy collection?
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :disabled="state.processing" flat @click="hide">Cancel</v-btn>
        <v-btn :disabled="state.processing" flat color="error" @click="deleteOverride">
          Remove
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import _ from "underscore";
import * as action from "@/store/levy-collection-overrides/action-types";
import * as lcpAction from "@/store/levy-collection-providers/action-types";
import { SHOW_NOTIFICATION } from "@/store/notifications/mutation-types";

export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    levyCollectionId: {
      validator: prop => typeof prop === "number" || prop === null,
      required: true
    },
    providerId: {
      validator: prop => typeof prop === "number" || prop === null,
      default: null
    }
  },
  data() {
    return {
      overrideId: null
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollectionOverrides.delete;
    }
  },
  watch: {
    async show(nowShowing) {
      if (nowShowing) {
        await this.$store.dispatch(lcpAction.VIEW_REFRESH, {
          levyCollectionId: this.levyCollectionId,
          providerId: this.providerId
        });
        this.overrideId = _(this.$store.state.levyCollectionProviders.view.data.overrides).find(
          o => o.category == "AddProvider"
        ).id;
      }
    }
  },
  methods: {
    async deleteOverride() {
      const succeeded = await this.$store.dispatch(action.EDIT_DELETE, {
        levyCollectionOverrideId: this.overrideId,
        levyCollectionId: this.levyCollectionId
      });
      this.hide();
      if (succeeded) {
        this.$router.replace(`/levy-collections/${this.levyCollectionId}/providers`);
        this.$store.commit(SHOW_NOTIFICATION, "Provider has been removed from the levy collection.");
      }
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
